export default __webpack_public_path__ + "703de23ea410c9d7eb3e9a21ad3d5921.png";